import { Outlet } from "react-router-dom";
import Preloader from "../pages/preload/Preloader";
import { Loader1, Loader2 } from "../../core/assets";
import { useEffect, useState } from "react";
import HoverEffect from "../components/custom-mouse/CustomMouse";

export const MainIndex = () => {
  const [video, setVideo] = useState(Loader1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handlePageReload = () => {
      setLoading(true);
      if (video === Loader1) {
        setVideo(Loader2);
      } else {
        setVideo(Loader1);
      }
    };
    window.addEventListener("unload", handlePageReload);
    return () => {
      window.removeEventListener("beforeunload", handlePageReload);
    };
  }, [video]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 8000);
  });

  return (
    <>
    {loading ? (
      <Preloader/>
    ): (
      <section className="mt-[-5%] md:mt-0 bg-white">
      <HoverEffect/>
      <Outlet />

    </section>
    )}
      
      
    </>
  );
};
